<template>
  <button
    class="app-button"
    :type="$attrs.type"
  >
    <span
      :class="`app-button__icon_${iconPosition}`"
      class="app-button__icon"
    >
      <component
        :is="icon"
      />
    </span>
    <span class="app-button__text">
      <slot/>
    </span>
  </button>
</template>

<script>
import IconLeftRow from '../Icons/IconLeftRow';
import IconRightRow from '../Icons/IconRightRow';

export default {
  name: 'AppButton',
  components: {
    IconLeftRow,
    IconRightRow,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    iconPosition: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right'].includes(value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  .app-button {
    font-size: 17px;
    height: 45px;
    background: linear-gradient(199.99deg, #65B5EA 0%, #1F50FB 99.2%);
    box-shadow: 0 4px 4px rgba(31, 80, 251, 0.2);
    border-radius: 8px;
    border: none;
    color: #ffffff;
    position: relative;
    padding: 0 30px;
    &__text {
      font-family: "Josefin Sans", sans-serif;
      font-style: normal;
      font-size: 17px;
    }
    &__icon {
      position: absolute;
      top: 0;
      transform: translateY(45%);

      &_left {
        left: 10px;
      }

      &_right {
        right: 10px;
      }
    }
    &:hover {
      background: linear-gradient(199.99deg, #68bcea 0%, #2c66fb 99.2%);
    }
    &:active {
      background: linear-gradient(199.99deg, #61aaea 0%, #1525fb 99.2%);
    }
  }
</style>
